import {
  getDictionaries,
  getDictionary,
  getRandomDictionaries,
  fuzzySearch,
} from 'utils/queries/dictionary';

export const dictionaryEndpoints = (build) => ({
  getDictionaries: build.query({
    query: (args) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getDictionaries,
        variables: args,
      }),
    }),
    transformResponse: (response) => response.data.getDictionaries,
  }),
  getDictionary: build.query({
    query: (id) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getDictionary,
        variables: { id },
      }),
    }),
    transformResponse: (response) => response.data.getDictionary,
  }),
  getRandomDictionaries: build.query({
    query: (args) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getRandomDictionaries,
        variables: args,
      }),
    }),
    transformResponse: (response) => response.data.getRandomDictionaries,
  }),
  fuzzySearch: build.query({
    query: (args) => ({
      method: 'POST',
      body: JSON.stringify({
        query: fuzzySearch,
        variables: args,
      }),
    }),
    transformResponse: (response) => response.data.fuzzySearch,
  }),
});
